// extracted by mini-css-extract-plugin
export default {"collectionChecklist":"CollectionChecklist__collectionChecklist-YLZv","heading":"CollectionChecklist__heading-Ouuw","subheading":"CollectionChecklist__subheading-TYRW"};